// =========================================================================================@@
// Last Updated Date: Mar 23, 2023
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React, { useState } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { View } from 'oio-react'
import { MoreIcon } from 'assets/icons'
import { useMe } from 'src/core/graphql/hooks'
import ListMenuButton from 'src/sites/kits/Global/components/ListMenuButton'
import { Button } from 'src/sites/kits/UI'

const buttonProps = {
   paddingHorizontal: '8px'
}

const LatestMoreButton = () => {
   const [popoverOpen, setPopoverOpen] = useState(false)
   const { isLoggedIn } = useMe()

   return (
      <DropdownMenu.Root
         open={popoverOpen}
         onOpenChange={open => setPopoverOpen(open)}>
         <DropdownMenu.Trigger>
            <Button
               height="var(--baseComponentBorderRadius-md)"
               width="var(--baseComponentBorderRadius-md)"
               size="md"
               paddingHorizontal="0px"
               color="transparent">
               <MoreIcon width="24px" height="24px" color="var(--listMenuButtonTextColor)" />
            </Button>
         </DropdownMenu.Trigger>
         <DropdownMenu.Portal>
            <DropdownMenu.Content
               className="ui-popover"
               collisionPadding={16}>
               <View onClick={() => setPopoverOpen(false)} width="180px">
                  {!isLoggedIn && (
                     <ListMenuButton
                        linkTo="/-/login"
                        name="Log In"
                        {...buttonProps}
                     />
                  )}
                  {isLoggedIn && (
                     <>
                        <ListMenuButton
                           linkTo="/-/profile"
                           name="View Profile"
                           {...buttonProps}
                        />
                     </>
                  )}
               </View>
            </DropdownMenu.Content>
         </DropdownMenu.Portal>
      </DropdownMenu.Root>
   )
}

export default LatestMoreButton
